// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1sxLf","modal":"Modal_modal__JroGm","slide-down":"Modal_slide-down__hPOBh"};